




















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    name: "FAQItem"
})
export default class FAQItem extends Vue {
    @Prop(String) readonly title!: string;
    @Prop(String) readonly text!: string;
    @Prop(Number) readonly index!: number;

    private visible: boolean = false

    get id(){
        //@ts-ignore
        return this._uid
    }

}

